export default Object.freeze({
  auto: 'auto',
  contain: 'contain',
  cover: 'cover'
});